import { gsap } from "gsap";

export default class Main{

    constructor() {
        this.$gheader = document.querySelector('.l-gheader');
        this.$ganv_trigger = document.querySelector('.l-gnav__trigger');
        this.$gnav_wrapper = document.querySelector('.l-gnav__wrapper');
        this.$gnav_bg = document.querySelector('.l-gnav__bg');
        this.$gnav_logo = document.querySelector('.l-gheader__logo');
        this.init();
    }

    init() {
        this.gnav();
        this.share();
        this.page_anim();
        this.pagenate_anim();
        this.lightcase();
    }

    gnav() {

        this.$ganv_trigger.addEventListener('click', ()=>{

            if(this.$ganv_trigger.classList.contains('-active')){
                this.$gnav_wrapper.classList.remove('-active');
                this.$gnav_bg.classList.remove('-active');
                this.$gnav_logo.classList.remove('-active');
                this.$ganv_trigger.classList.remove('-active');
                this.$gheader.classList.remove('-open');
            }
            else{
                this.$gheader.classList.add('-open');
                this.$gnav_bg.classList.add('-active');
                this.$ganv_trigger.classList.add('-active');

                setTimeout(() => {
                    this.$gnav_wrapper.classList.add('-active');
                    this.$gnav_logo.classList.add('-active');
                }, 400);
            }
        });
    }

    share() {
        
        if(document.querySelector('.l-share') !== null){
            const $share = document.querySelector('.l-share');
            const $btn = $share.querySelector('.l-share__btn');

            $btn.addEventListener('mouseover', () => {
                $share.classList.toggle('-active');
            });

            document.addEventListener('mouseover', (e) => {
                if(!e.target.closest('.l-share')) $share.classList.remove('-active');
            });
        }
        
    }

    page_anim() {
        const $curtains = document.querySelectorAll('.js-curtain');
        const $ttls = document.querySelectorAll('.js-anim_ttl');
        const $ins = document.querySelectorAll('.js-in_anim');
        const $circles = document.querySelectorAll('.js-circle_anim');

        $curtains.forEach(el => el.classList.add('-active'));

        setTimeout(() => {
            $ttls.forEach(el => el.classList.add('-active'));
            $ins.forEach(el => el.classList.add('-active'));
            $circles.forEach(el => el.classList.add('-active'));
        }, 500);
    }
    
    pagenate_anim() {
        if(!document.querySelector('.js-pagenate')) return;
        
        document.querySelector('.js-pagenate a').addEventListener('click', e=>{
            e.preventDefault();
            gsap.fromTo('.js-pagenate', { duration: 0.5, rotation: '180deg' }, { rotation: 0 });

            setTimeout(() => {
                location.href = $(this).attr("href");
            }, 500);
        });
    }

    lightcase() {
        $(".js-lightcase_html").lightcase({
            iframe: {
                width: "800px",
                height: "460px",
            },
        });
    }
}
